import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16 10H4", stroke: "#2F3337", strokeWidth: 1.66667, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 16V4", stroke: "#2F3337", strokeWidth: 1.66667, strokeMiterlimit: 10, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
